import classNames from "classnames";
import React from "react";
import Icon from "~/assets/icons/Icon";
import Button, { ButtonProps } from "~/components/Button";

export interface BuyButtonProps extends ButtonProps {
  loading?: boolean;
}

export default function BuyButton(props: BuyButtonProps): JSX.Element {
  const { children, loading, ...restProps } = props;

  const textClasses = classNames("transition-opacity duration-200", {
    "opacity-0": loading,
  });

  const iconClasses = classNames(
    "transition-opacity duration-200 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
    {
      "opacity-0": !loading,
    }
  );

  return (
    <Button variant="primary" size="xl" className="relative" {...restProps}>
      <span className={textClasses}>{children}</span>
      <div className={iconClasses}>
        <Icon name="spinner" className="animate-spin w-6 h-6" />
      </div>
    </Button>
  );
}
